<template>
  <q-timeline-entry
    :color="isNew ? 'secondary' : 'grey-5'"
    class="change-log-timeline"
  >
    <template #title>
      <div class="row">
        <span class="fs-190 text-capitalize">{{ changelog.title }}</span>
        <div
          v-if="isNew"
          class="single-badge secondary rounded dense q-ml-sm"
        >
          Nouveau
        </div>
      </div>
    </template>
    <template #subtitle>
      <span class="text-weight-medium fs-70 op-70 q-mb-sm">{{ dayjs(changelog.versionDate).tz().format('LL') }}</span>
    </template>
    <markdown-editor
      :editor-id="'change-log-md-editor-' + changelog.id"
      preview-only class="q-mb-lg"
      style="background-color: transparent!important;"
      :theme="$q.dark.isActive || dark ? 'dark': 'light'"
      :model-value="changelog.content"
      :preview-theme="'github'"
    />
  </q-timeline-entry>
</template>

<script setup>
  import dayjs from 'dayjs'
  import MarkdownEditor from 'src/modules/core/components/MarkdownEditor.vue'
  import { useQuasar } from 'quasar'

  const $q = useQuasar()

  defineProps({
    changelog: {
      type: Object,
      required: true
    },
    isNew: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  })
</script>

<style lang="scss" scoped>
  .change-log-timeline {
    :deep(.q-timeline__title) {
      margin-bottom: 3px !important;
    }

    :deep(.q-timeline__subtitle) {
      opacity: 1;
    }

    :deep(*) {
      word-break: break-word !important;
    }
  }
</style>
